class BlazeCarousel extends HTMLElement {
  constructor() {
    super()

    this.el = this.querySelector('.blaze-slider');  
    this.init();
  }

  init() {
    return new BlazeSlider(this.el, {
      all: {
        enableAutoplay: true,
        autoplayInterval: 3000,
        transitionDuration: 1000,
        slidesToShow: 7,
        slideGap: '5rem'
      },
      '(max-width: 1024px)': {
        slidesToShow: 5,
      },
      '(max-width: 900px)': {
        slidesToShow: 5,
      },
      '(max-width: 500px)': {
        slidesToShow: 3,
      },
    })
  }
}

customElements.define('blaze-carousel', BlazeCarousel)